export const deepClone = (item: any): any => {
  if (Array.isArray(item)) {
    return item.map((element) => deepClone(element));
  }

  if (item !== null && typeof item === 'object') {
    return Object.keys(item).reduce((acc, key) => {
      acc[key] = deepClone(item[key]);
      return acc;
    }, {} as Record<string, any>);
  }

  return item;
};

export const stripTrailingSlashes = (pathname: string) => {
  let cleanedPath = pathname;
  // strip any trailing slashes
  if (cleanedPath.endsWith('/')) {
    cleanedPath = cleanedPath.slice(0, cleanedPath.length - 1);
  }

  return cleanedPath;
};

export const hasTouchSupport = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};
